export default {
	lang: 'de',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'Kontosicherheit',
		"nav1": 'Meine Laufwerk',
		"nav2": 'Abmelden',
		"nav3": 'Anmelden/Registrieren',
		"nav4": 'Sie können Anrufe und Audioinhalte auf Ihrem Telefon aufnehmen und in Text umwandeln. Für die Verwendung ist ein Kopfhörer der VTransBUDS-Serie erforderlich.',
		"nav5": 'Scancode herunterladen',
		"nav6": 'Wichtige Kommunikation, effizientes Rückverfolgen',
		"speaker_not_null": 'Der Sprecher kann nicht bearbeitet werden! ',
		"sprecher": "Sprecher",
		"copy_success": 'Erfolgreich kopiert',
	},
	login: {
		 "login1": 'Passwort zur Anmeldung',
		 "login2": 'SMS-Anmeldung',
		 "loginTab3": 'Mail-Anmelden',
		 "login3": 'Postfach',
		 "login4": 'Einloggungskennwort',
		 "login5": 'Telefonnummer',
		 "login6": 'Bitte auswählen',
		 "login7": 'Telefonnummer',
		 "login8": 'Anmelden',
		 "login9": 'Passwort vergessen',
		 "login10": 'Registrieren',
		 "login11": 'Mit dem Login stimmen Sie zu',
		 "login12": 'Dienstleistungsvereinbarung',
		 "login13": 'Datenschutzvereinbarung',
		 "login14": 'Erhalten',
		 "login15": 'Deutschland',
		 "login16": 'Bitte geben Sie Ihre Kontonummer ein',
		 "login17": 'Bitte geben Sie Ihr Passwort ein',
		 "login18": 'Login erfolgreich! ',
		 "login19": 'Bitte geben Sie den Verifikationscode ein! ',
		 "login20": 'Erfolgreich gesendet! ',
		 "login21": 'und',
		 "login22": 'Aufnahmeschreiber',
		 "login23": 'Mein Schreiben',
		 "login24": 'Mein Gespräch',
		 "login25": 'Kontosicherheit',
		 "login26": 'Abmelden',
		 "login27": 'Passwort zurückfinden',
		 "login28": 'Postfach',
		 "login29": 'Postleitzahl',
		 "login30": 'Einloggungskennwort festlegen (6-16 Zeichen)',
		 "login31": 'Geben Sie Ihr Passwort erneut ein',
		 "login32": 'Einreichen',
		 "login33": 'Zurück zum Login',
		 "login34": 'Änderung erfolgreich! ',
	},
	register: {
		 "register1": 'Telefonnummer',
		 "register2": 'Bitte geben Sie Ihr Handy ein',
		 "register3": 'Bitte auswählen',
		 "register4": 'Telefonnummer',
		 "register5": 'Passwort festlegen',
		 "register6": 'Bitte geben Sie den Verifikationscode ein',
		 "register7": '6-16-Bit-Zeichen',
		 "register8": 'Passwortbestätigung',
		 "register9": 'Postfach',
		 "register10": 'Bitte geben Sie Ihr Postfach ein',
		 "register11": 'Postleitzahl',
		 "register12": 'Bitte geben Sie den Verifikationscode ein',
		 "register13": 'Ich habe gelesen und stimme zu',
		 "register14": 'Bitte lesen und markieren Sie die Einwilligungsvereinbarung',
		 "register15": 'Telefonnummer falsch formatiert / Telefonnummer registriert',
		 "register16": 'Telefonnummer falsch',
		 "register17": 'Bitte geben Sie ein falsches Postfach / Postfach ein',
		 "register18": 'Fehler Postfachformat',
		 "register19": 'Fehler im E-Mail-Code',
		 "register20": 'Passwort Bitte setzen Sie 6-16 Bit Zeichen',
		 "register21": 'Falsches Passwortformat',
		 "register22": 'Zweimal eingegebenes Passwort stimmt nicht überein, bitte erneut ein',
		 "register23": 'Bitte geben Sie Ihr Passwort ein',
		 "register24": 'Registrierung erfolgreich! ',
		 "register25": 'Verifikationscode falsch',
	},
	recorder: {
		 "recorder1": 'Meine Festplatte',
		 "recorder2": 'Wolkenkapazität',
		 "recorder3": 'Letzte Datei',
		 "recorder331":'Papierkorb',
		 "recorder332":'Alles löschen',
		 "recorder4": 'Name',
		 "recorder5": 'Laufzeit',
		 "recorder6": 'Dateigröße',
		 "recorder7": 'Erstellungszeit',
		 "recorder8": 'Aktion',
		 "recorder9": 'Beschreibung des Cloud Spaces',
		 "recorder10": 'Audio',
		 "recorder11": 'OCR-Datei',
		 "recorder12": '1. Wozu dient der Cloud-Raum? ',
		 "recorder13": 'Nachdem die Aufnahme auf dem Stift abgeschlossen ist, können Sie Audio hochladen und Dateien in die Cloud überschreiben, auch wenn der Stift nicht in der Nähe ist, können Sie in die Cloud gehen, um das Audio zu sehen. ',
		 "recorder14": '2. Wie kann ich den Cloud-Raum hochladen? ',
		 "recorder15": 'Gehen Sie auf Ihrem Stift zu "Meine Dateien", wählen Sie die Option "Lange Datei" und klicken Sie auf "Hochladen", um die Datei in die Cloud hochzuladen. ',
		 "recorder16": '3. Wie kann ich Cloud-Dateien anzeigen/verwalten? ',
		 "recorder17": 'Melden Sie sich auf der offiziellen PayPal-Website an und wählen Sie "Mein-Recorder-Drive" aus, um die hochgeladenen Recorder-Dateien anzuzeigen. Sie können Zieldateien zum Herunterladen, Löschen usw. auswählen. Sie können den Cloud-Speicher reinigen, indem Sie die Cloud-Dateien löschen! ',
		 "recorder18": 'Nicht überschrieben',
		 "recorder19": 'Zusammenfassung anzeigen',
		 "recorder20": 'Sprecher',
		 "recorder21": 'Rednernamen bearbeiten',
		 "recorder22": 'OK',
		 "recorder23": 'Herunterladen',
		 "recorder24": 'Inhalt heruntergeladen:',
		 "recorder25": 'Download-Einstellungen:',
		 "recorder26": 'Sprecher anzeigen',
		 "recorder27": 'Abbrechen',
		 "recorder28": 'Link teilen',
		 "recorder29": 'Zugänglich für alle, die den Link erhalten, nur Lesen unterstützt, der Link ist 7 Tage gültig',
		 "recorder30": 'Link kopieren',
		 "recorder31": 'Schnell durchsuchen',
		 "recorder32": 'Intelligente Aufstellung',
		 "recorder33": 'Sprecher unterscheiden',
		 "recorder34": 'Intelligente Unterscheidung von Transkriptionstexten nach der Rolle des Sprechers',
		 "recorder35": 'Intelligente Sprachregelung',
		 "recorder36": 'Automatisches Filtern von Tonwörtern, Wiederholungen und Pausen',
		 "recorder37": 'Nichtmenschliches Filtern',
		 "recorder38": 'Automatisch überspringen Sie unbekanntes, geräuschtes Audio während der Wiedergabe',
		 "recorder39": 'Bitte auswählen',
		 "recorder40": 'Dokument',
		 "recorder41": 'Audio',
		 "recorder42": 'Dokument + Audio',
		 "recorder43":'Tipp',
		 "recorder44":'Diese Aktion wird die Datei löschen, werden Sie fortfahren? ',
		 "recorder441": 'Dieser Vorgang löscht alle Dateien, wollen wir weitermachen?',
		 "recorder45":'OK',
		 "recorder46":'Abbrechen',
		 "recorder47":'Löschung erfolgreich! ',
		 "recorder48":'Entfernt',
		 "recorder49":'Keine Kennzeichnung',
		 "recorder50":"Speichern...",
		 "recorder51":'Papierkorb',
	},
	personal: {
		 "personal1": 'Kontoeinstellungen',
		 "personal2": "Persönliche Daten",
		 "personal3": 'Vorbild',
		 "personal4": 'Datei hochladen',
		 "personal5": 'Unterstützt JPG, JPEG, GIF, PNG-Stile, unterstützt Bilder bis zu 2M',
		 "personal6": 'Spitzname',
		 "personal7": 'Bitte geben Sie einen Spitznamen ein',
		 "personal8": 'Geschlecht',
		 "personal9": "Herr",
		 "personal10": "Frau",
		 "personal11": "Vertraulichkeit",
		 "personal12": 'Geburtstag',
		 "personal13": 'Bitte Geburtstag auswählen',
		 "personal14": 'Beruf',
		 "personal15": 'Bitte wählen Sie Ihre Berufsbildung',
		 "personal16": 'Bitte geben Sie Ihren Beruf ein (nicht erforderlich)',
		 "personal17": "Land",
		 "personal18": 'Bitte wählen Sie ein Land',
		 "personal19": 'Speichern',
		 "personal20": 'Persönliche Daten',
		 "personal21": 'Kontosicherheit',
		 "personal22": "Unterstützt nur Bilder innerhalb von 2M",
		 "personal23": 'Erfolgreich hochgeladen! ',
		 "personal24": 'Änderung erfolgreich! ',
		 "personal25": 'Kontosicherheit',
		 "personal26": 'Anmeldekennwort',
		 "personal27": 'Ändern',
		 "personal28": 'E-Mail-Adresse',
		 "personal29": 'Ersatz',
		 "personal30": 'Konto abmelden',
		 "personal32": 'Sind Sie sicher, dass Sie Ihr Konto abmelden? ',
		 "personal33": 'Wenn Sie sich abmelden, werden alle Inhalte in Ihrem Konto gelöscht, bitte handeln Sie vorsichtig. ',
		 "personal34": 'Abbrechen',
		 "personal35": 'OK',
		 "personal36": 'Authentifizierung',
		 "personal37": 'Bitte verifizieren Sie sich per E-Mail-Verifikationscode, um zu bestätigen, dass Sie selbst tätig sind',
		 "personal38": 'Postfach',
		 "personal39": 'Verifikationscode',
		 "personal40": 'Bitte geben Sie den Verifikationscode ein',
		 "personal41": 'Nächster Schritt',
		 "personal42": 'Neues Postfach einrichten',
		 "personal43": 'Postfach',
		 "personal44": 'Bitte geben Sie ein neues Postfach ein',
		 "personal45": 'Verifizierungscode',
		 "personal46": 'Bitte geben Sie den Verifikationscode ein',
		 "personal47": 'OK',
		 "personal48": 'Neues Anmeldekennwort festlegen',
		 "personal49": 'Neues Passwort',
		 "personal50": 'Bitte geben Sie ein neues Passwort ein',
		 "personal51": 'Neues Passwort bestätigen',
		 "personal52": 'Bitte geben Sie erneut ein neues Passwort ein',
		 "personal53": 'OK',
		 "personal54": 'Erhalten',
		 "personal55": 'Fehler Postfachformat',
		 "personal56": 'Ersatz erfolgreich! ',
		 "personal57": 'Passwort bitte 6-16 Bit Zeichen festlegen',
		 "personal58": 'Zweimal eingegebenes Passwort ist nicht übereinstimmend',
		 "personal59": 'Änderung erfolgreich!',
		 "personal60": 'Abmelden erfolgreich!',
		 "share_url": "Link teilen",
		 "share_url_7_day": "Der Freigabelink ist 7 Tage gültig. Vor Ablauf kann jeder, der den Link erhält, darauf zugreifen.",
		 "share_audio": "Audioaufnahme",
		 "share_trans_text": "Transkription",
		 "share_summny_text": "Zusammenfassung",
		 "share_map": "Mindmap",
		 "share_url_pw": "Zugriffsverschlüsselung",
		 "share_random_pw": "Zufällig generiertes Passwort",
		 "share_url_copy": "Link kopieren",
		 "share_link_pw": "Zugriffspasswort",
		 "share_copy_success": "Erfolgreich kopiert!",
		 "share_speaker": "Sprecher",
		 "share_no_update_speaker": "Sprecher kann nicht bearbeitet werden. Leerer Eintrag",
		 "share_no_trans":"Keine Transkription",
		 "share_no_summny":"Keine Zusammenfassung",
		 "share_no_map":"Keine Karte Inhalt",
		 "share_trans_text_1": "Transkription",
		 "share_summny_text_1": "Zusammenfassung",
		 "share_map_1": "Karte",
		 "share_save": "Erfolgreich gespeichert",
		 "share_no_map": "Kartenbild nicht erstellt",
		 "share_update_text": "Transkriptionstext bearbeiten",
		 "share_update_text2": "Zusammenfassungstext bearbeiten",
		"showLoading": "Laden...",
	}
}